import { update } from "lodash";

export const API_BASE_URL = 'https://slashmusic.link/api/v1';
export const SUNO_API_BASE_URL = 'https://slashmusic.link/api';
export const SUNO_API_STORAGE_URL = 'https://slashmusic.link/storage';
export const BASE_URL_SHARE = 'https://dashboard.slashmusic.net';

export const API_URLS = {
  SignUp: '/register',
  SignIn: '/auth',
  AuthSocial: '/auth/social',
  SignUpVerify: '/email/verify/{id}/{hash}',
  Countries: '/countries',
  CountryGroups: '/country-groups',
  updateCountryGroup: '/country-groups/{country_group}',
  ResendSignUpVerification: '/resend-verification',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  User: '/user',
  Releases: '/releases',
  Release: '/releases/{release}',
  Platforms: '/platforms',
  PlatformGroups: '/platform-groups',
  Artists: '/artists',
  Contributors: '/contributors',
  ContributorsRoles: '/contributors/roles',
  ContributorsInstruments: '/contributors/instruments',
  Genres: '/genres',
  Labels: '/labels',
  Tracks: '/tracks',
  TracksRole:'/tracks/{track}/artists/{artist}/set-role',
  CheckLabelAvailability: '/check-label-availability',
  ReleaseTracks: '/releases/{release}/tracks',
  TrackDelete: '/releases/{release}/tracks/{track}',
  audio: '/tracks/{track}/stream',
  Social: '/artists/{artist}/socials',
  UpdateSocialLink: '/artists/{artist}/socials/{social}',
  CreateSocialLink: '/artists/{artist}/socials',
  Authors: '/contributors',
  Role: '/releases/{release}/artists/{artist}/set-role',
  Localization: '/localization/{locale}',
  Languages: '/languages',
  Analytics: '/reports/overview',
  PlatformGroupsUpdate: '/platform-groups/{platformGroup}',
  AnalyticsFilters: '/analytics/filters',
  ReleaseArtistsReorder: '/releases/{releaseId}/artists/reorder',
  TracksReorder: '/releases/{release}/tracks/reorder',
  TracksArtistsReorder: '/tracks/{track}/artists/reorder',
  ReleasesSubmit: '/releases/{releaseId}/submit',
  releaseCheckout: "/releases/{release}/checkout",
  releasePay: "/releases/{release}/checkout/session",
  ReleaseValidate: '/releases/{release}/validate',
  ReleaseTypes: '/release-types',
  smartLink: '/smart-links',
  smartLinkDelete: '/smart-links/{smart_link}',
  SunoWorkspaces: '/suno/workspaces',
  SunoPlaylists: '/suno/playlists',
  SunoGenerate: '/suno/generate',
  SunoGenerateRecordInfo: '/suno/generate/record-info',
  SunoLyrics: '/suno/lyrics',
  SunoLyricsRecordInfo: '/suno/lyrics/record-info',
  SunoMiniPrompts: '/suno/gpt/mini-prompts',
  SunoStyles: '/suno/gpt/styles',
  SunoSongConcept: '/suno/gpt/song',
  SunoGeneratePersona: '/suno/generate/generate-persona',
  SunoPersons: '/suno/persons',
  SunoWavGenerate: '/suno/wav/generate',
  SunoWavRecordInfo: '/suno/wav/record-info',
  SunoTrack: '/suno/tracks/{track}',
  SunoTrackMove: '/suno/tracks/{track}/move',
  SunoTrackReaction: '/suno/tracks/{track}/reaction',
  SunoPublicTrack: '/suno/tracks/{uuid}',
  SunoPublicPlaylist: '/suno/playlists/{uuid}',
  SunoPlaylistTracks: '/suno/playlists/{playlist}/tracks',
  SunoPlaylistTrack: '/suno/playlists/{playlist}/tracks/{track}',
  smartLinksOverview:'/smart-links/{smart_link}/analytics/overview',
  smartLinksTimeseries:"/smart-links/{smart_link}/analytics/timeseries",
  smartLinksCountries:"/smart-links/{smart_link}/analytics/countries"



};

export const LOCALSTORAGE_TOKEN_ITEM = "token"
